import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion';

const AnimatedCounter = ({ target, suffix = '', duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const numericTarget = parseInt(target, 10);

  useEffect(() => {
    let start = 0;
    const increment = numericTarget / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= numericTarget) {
        setCount(numericTarget);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [numericTarget, duration]);

  return <>{count}{suffix}</>;
};

const Counter = ({fadeUp}) => {
  return (
    <motion.div
    variants={fadeUp}
    className="mt-14 flex items-center gap-10 md:gap-14"
    >
        {[
            { value: '10', suffix: 'K+', label: 'Graduates' },
            { value: '200', suffix: '+', label: 'Courses' },
            { value: '50', suffix: '+', label: 'Partners' },
        ].map((stat, i) => (
            <div key={stat.label} className="flex items-center gap-10">
            {i > 0 && <div className="w-px h-10 bg-dark/10 -ml-5 md:-ml-7" />}
            <div>
                <div className="text-3xl md:text-4xl font-extrabold text-dark tracking-tight">
                <AnimatedCounter target={stat.value} suffix={stat.suffix} />
                </div>
                <div className="text-sm text-dark/35 font-medium mt-1 tracking-wide">
                {stat.label}
                </div>
            </div>
            </div>
        ))}
    </motion.div>
  )
}

export default Counter